import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { useFormContext } from '../../../context/FormContext';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { Select } from '../../ui/Select';

const { FiPlus, FiTrash2 } = FiIcons;

const FREQUENCY_OPTIONS = [
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Quarterly', value: 'quarterly' },
  { label: 'Annually', value: 'annually' },
  { label: 'Ad-hoc', value: 'adhoc' }
];

export const LifecycleSection = () => {
  const { data, updateFormSection } = useFormContext();
  const lifecycle = data.form.lifecycle;

  const addRow = () => {
    updateFormSection('lifecycle', [...lifecycle, { id: Date.now(), name: '', usefulLife: '', replacementDate: '', maintFreq: '', maintCost: '', notes: '' }]);
  };

  const removeRow = (id) => updateFormSection('lifecycle', lifecycle.filter(l => l.id !== id));
  const updateField = (id, field, value) => updateFormSection('lifecycle', lifecycle.map(l => l.id === id ? { ...l, [field]: value } : l));

  return (
    <div className="space-y-6">
      {lifecycle.map((l, index) => (
        <div key={l.id} className="p-6 border border-brand-border rounded-2xl bg-brand-light/20">
          <div className="flex justify-between items-center mb-6">
            <h4 className="text-sm font-bold text-brand-text uppercase tracking-tight">Lifecycle Policy {index + 1}</h4>
            {lifecycle.length > 1 && (
              <button onClick={() => removeRow(l.id)} className="text-brand-muted hover:text-red-500 transition-colors">
                <SafeIcon icon={FiTrash2} />
              </button>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Input label="Asset Name" value={l.name} onChange={e => updateField(l.id, 'name', e.target.value)} />
            <Input label="Life Expectancy (Years)" type="number" value={l.usefulLife} onChange={e => updateField(l.id, 'usefulLife', e.target.value)} />
            <Input label="Est. Replacement Date" type="date" value={l.replacementDate} onChange={e => updateField(l.id, 'replacementDate', e.target.value)} />
            <Select 
              label="Maintenance Frequency" 
              options={FREQUENCY_OPTIONS}
              value={l.maintFreq}
              onChange={val => updateField(l.id, 'maintFreq', val)}
            />
            <Input label="Est. Maintenance Cost" type="number" value={l.maintCost} onChange={e => updateField(l.id, 'maintCost', e.target.value)} />
            <Input label="Notes" value={l.notes} onChange={e => updateField(l.id, 'notes', e.target.value)} />
          </div>
        </div>
      ))}
      <Button variant="outline" onClick={addRow} className="w-full border-dashed py-5 bg-white/40">
        <SafeIcon icon={FiPlus} className="mr-2" /> Add Lifecycle Record
      </Button>
    </div>
  );
};